import {program} from "gatsby/dist/redux/reducers";

export class Shader{
    static vertex = `attribute vec3 position;
uniform mat4 mvpMatrix;

void main(void){
    gl_Position = mvpMatrix * vec4(position, 1.0);
}`;
    static fragment = `
void main(void)
{
    gl_FragColor = vec4(1.0,0.0,0.0,1.0);
}`;

    static SimpleColorFrag = (r:number,g:number,b:number) => {
        return`   
precision highp float;
uniform vec3 color;     
void main(void)
{
    gl_FragColor = vec4(${r/255.0},${g/255.0},${b/255.0},1.0);
}`;
    }

    static UniformColorFrag = () => {
        return`
precision highp float;
uniform vec3 color;        
void main(void)
{
    gl_FragColor = vec4(color/255.0,1.0);
}`;
    }

    static SimpleInstanceVertex = () => {
        return`
precision highp float;
attribute vec3 position;
attribute vec3 instancePos;
attribute vec3 instanceRot;
uniform mat4 mvpMatrix;

void main(void){
    vec3 pos = position;
    pos.xy = mat2(cos(instanceRot.z),-sin(instanceRot.z),sin(instanceRot.z),cos(instanceRot.z)) * pos.xy;
    gl_Position = mvpMatrix * vec4(pos + instancePos, 1.0);
}
        `;
    }

    static TubeInstanceVertex = () => {
        return`
precision highp float;
attribute vec3 position;
attribute vec3 fromPos;
attribute vec3 toPos;
uniform mat4 mvpMatrix;
uniform vec3 radius;

void main(void){
    vec3 dir = normalize(toPos - fromPos);
    float len = length(toPos - fromPos);
    vec3 vecA = normalize(cross(dir,dir+vec3(1.0,0.0,0.0)));
    vec3 vecB = normalize(cross(dir,vecA));
    vec3 pos = dir * position.z * len + vecA * position.y * radius.x + vecB * position.x * radius.x;
    pos = (len < 0.001 || radius.x < 0.001) ? vec3(0.0,0.0,0.0) : pos;
    gl_Position = mvpMatrix * vec4(pos + fromPos, 1.0);
}
        `;
    }

    static CreateShader = (vertex:string,fragment:string,gl:WebGLRenderingContext) => {
        const vs = gl.createShader(gl.VERTEX_SHADER);
        const fs = gl.createShader(gl.FRAGMENT_SHADER);
        console.log("Creating Shader...");
        if(vs && fs){
            gl.shaderSource(vs,vertex);
            gl.shaderSource(fs,fragment);
            gl.compileShader(vs);
            gl.compileShader(fs);
            console.log("Compiling Shader...");
            if(gl.getShaderParameter(vs,gl.COMPILE_STATUS) && gl.getShaderParameter(fs,gl.COMPILE_STATUS)){
                console.log("Compiled");
                const program = gl.createProgram();
                if(program){
                    console.log("Program Created");
                    gl.attachShader(program,vs);
                    gl.attachShader(program,fs);
                    gl.linkProgram(program);
                    if(gl.getProgramParameter(program,gl.LINK_STATUS)){
                        gl.useProgram(program);
                        return program;
                    }else{
                        console.log(gl.getProgramInfoLog(program));
                    }
                }
            }else{
                console.log(gl.getShaderInfoLog(vs));
                console.log(gl.getShaderInfoLog(fs));
            }
        }

    }

}